// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_U2w","cls2":"AuthorPopover-cls2_4Jk AuthorPopover-cls1_U2w","secondary":"AuthorPopover-secondary_LcT"};